import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const StyledContainer = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 auto',
  objectFit: 'contain',
});

export const NoVideoWrapper = styled(Box)({
  position: 'relative',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '90%',
  maxWidth: '336px',
  maxHeight: '620px',
});

export const GlassContainer = styled(Box)({
  zIndex: 1,
  overflow: 'auto',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '50px 0 15px 0',
  position: 'relative',
  top: '40%',
  transform: 'translateY(-50%)',
});

export const GlassBackground = styled(Box)({
  background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.46) 35.94%, rgba(0, 0, 0, 0.46) 100%)',
  backdropFilter: 'blur(1px)',
});

export const VenueLogo = styled('img')({
  position: 'absolute',
  width: 'auto',
  height: 46,
  zIndex: 10000,
  top: 0,
  left: '50%',
  transform: 'translateX(-50%)',
});

export const PlayIcon = styled(Box)({
  '&:hover': {
    opacity: '0.9',
  },
  position: 'absolute',
  width: '54px',
  height: '54px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 100000,
});

export const MuteIcon = styled(Box)({
  '&:hover': {
    opacity: '0.9',
  },
  position: 'absolute',
  width: '54px',
  height: '54px',
  bottom: '30px',
  right: '30px',
  zIndex: 100001,
});

export const ControlsWrapper = styled(Box)({
  width: '100%',
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: 'all 0.35s ease-in-out',
  zIndex: 100000,
});

export const LogoNoVideoWrapper = styled(Box)({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  overflow: 'hidden',
});

export const CompanyName = styled(Typography)({
  fontSize: '28px',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '30px',
  color: '#fff',
});

export const RecordVideoText = styled(Typography)({
  fontSize: '40px',
  fontWeight: 600,
  lineHeight: '111%',
  letterSpacing: '0.4px',
  textAlign: 'center',
  maxWidth: '90%',
  margin: '0 auto',
});

export const RecordVideoLengthText = styled(Typography)({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '14px',
  textAlign: 'center',
  marginTop: '35px',
});

export const ControlsWrapperNoVideo = styled(Box)({
  position: 'absolute',
  bottom: 0,
  left: '50%',
  transform: 'translateX(-50%)',
});

export const VanueName = styled(Box)({
  position: 'absolute',
  width: '90%',
  top: '109px',
  left: '50%',
  transform: 'translateX(-50%)',
  padding: '40px 10px',
  background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.45) 35.94%, rgba(0, 0, 0, 0.45) 100%)',
  borderRadius: '12px',
  fontSize: '28px',
  fontWieght: 700,
  textAlign: 'center',
});
